export function convertIcadServiceDateToDate(date) {
  // Date format YYYY-MM-DD
  if (date) {
    const dateArray = date.split('-');
    return new Date(Date.UTC(dateArray[0], parseInt(dateArray[1]) - 1, dateArray[2]));
  }
}
